export default "__VITE_ASSET__Den5$7ez__"